/**
 * Validated client-side environment variables. Vite only exposes vars
 * prefixed with VITE_. See PRD §2.4.
 */
import { z } from 'zod';

const envSchema = z.object({
  MODE: z.enum(['development', 'production', 'test']).default('development'),
  VITE_API_URL: z.string().url().default('http://localhost:3001'),
  VITE_SUPABASE_URL: z.string().url(),
  // New asymmetric key system — sb_publishable_* replaces legacy anon key.
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(1),
  // Web push public key (Phase 5). Optional — push disabled if absent.
  VITE_VAPID_PUBLIC_KEY: z.string().min(1).optional(),
});

export const env = (() => {
  const parsed = envSchema.safeParse(import.meta.env);
  if (!parsed.success) {
    console.error('Invalid VITE_ environment variables:', parsed.error.flatten());
    throw new Error('Environment validation failed');
  }
  return parsed.data;
})();
